import FormGroup from 'bee-form-group'

export default FormGroup
